import { useCallback } from 'react';
import { getRuntimeConfig } from '@eis/core';
import { browserWindow, returnToSuite, type ReturnOutcome } from './returnToSuite';

/**
 * The legacy admin's address for this environment, and the one action that leads there.
 *
 * Read from runtime config at call time rather than captured at module load: Storybook and tests
 * inject their config after the bundle is evaluated, and a shell that captured `suiteUrl` once
 * would carry a stale address into the next scenario.
 */
export function useSuiteUrl(): string {
  return getRuntimeConfig().chrome.suiteUrl;
}

/** Back — focus the legacy tab and close, or navigate to its dashboard (U-5'). */
export function useReturnToSuite(): () => ReturnOutcome {
  const suiteUrl = useSuiteUrl();
  return useCallback(() => returnToSuite({ suiteUrl }, browserWindow()), [suiteUrl]);
}
